import { Injectable } from '@angular/core';
import { NotificationService, DataService, LoaderService, ErrorService, EVENTO, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { SessionInfo } from "../../../../shared/session/SessionInfo";

@Injectable()
export class RolAccessService {
  constructor(private dataService: DataService, private errorService: ErrorService, private notificationService: NotificationService,
    private loaderService: LoaderService, private utilityService: UtilityService, private sessionInfo: SessionInfo) { }

  asignarRolAccessUrl: string = 'roleAccess/insertar'
  deleteRolAccessUrl: string = 'roleAccess/delete'

  toggleRolAccess(AccessID: number, RoleID: number, AplicacionID: number, identificador: boolean) {
    let parameters: string;
    parameters = JSON.stringify({
      RoleID: RoleID,
      AplicacionID: AplicacionID,
      AccessID: AccessID,
    })
    if (identificador)
      this.dataService.set(this.asignarRolAccessUrl);
    else
      this.dataService.set(this.deleteRolAccessUrl);

    return this.dataService.execPostJson(parameters);
  }
}
